/**
 * Recorta a área escolhida no react-easy-crop (pixels da imagem original) num
 * quadrado `size`×`size` e devolve um PNG. O redondo é só na tela: o checkout
 * já mostra a foto num círculo, e o backend re-encoda o arquivo.
 */
export function cropToBlob(imageSrc, area, size = 512) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, size, size);
            canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Não foi possível recortar a imagem'))), 'image/png');
        };
        img.onerror = () => reject(new Error('Não foi possível abrir a imagem'));
        img.src = imageSrc;
    });
}
